module.exports = __webpack_public_path__ + "static/media/dentistchair.0a366df3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moonsflow/dentistchair.svg
// module id = 650
// module chunks = 0